import Block from "./Block"; // Импортваме съществуващия компонент Block

const BlockManager = ({
  blocks,
  addBlock,
  updateBlock,
  removeBlock,
  moveBlockUp,
  moveBlockDown,
}) => {
  return (
    <div className="my-4">
      {blocks.map((block, index) => (
        <Block
          key={index}
          block={block}
          index={index}
          isFirst={index === 0}
          isLast={index === blocks.length - 1}
          updateBlock={updateBlock}
          removeBlock={removeBlock}
          moveBlockUp={moveBlockUp}
          moveBlockDown={moveBlockDown}
        />
      ))}
      <button
        type="button"
        onClick={addBlock}
        className="px-4 py-2 mt-4 text-white rounded bg-fordBlue"
      >
        Добави нов блок
      </button>
    </div>
  );
};

export default BlockManager;
